<template>
    <modal v-model="toggleModal"
           class="createChildModal"
           :size="forms.addManually ? 'xl' : 'md'"
           :title="trans(`general.page.children.add_children`)"
           ref="modal"
           @close="reset">

        <div class="formChange border-radius-default bg-gray-200 gap-1 p-1 w-100 d-flex justify-content-center mb-4 position-relative">
            <basic-button
                :cls="['position-relative btn-fluid', forms.invite ? 'bg-white shadow-sm' : 'btn-secondary']"
                :text="trans('general.quick_call.add_child.send_invite')"
                @click="switchForms('invite')"/>
            <basic-button
                :cls="['position-relative btn-fluid', forms.addManually ? 'bg-white shadow-sm' : 'btn-secondary']"
                :text="trans('general.quick_call.add_child.manually')"
                @click="switchForms('addManually')"/>
        </div>

        <div v-if="forms.invite">
            <invite :props="{form: 'child_enrollment', nextStep: false, scope: 'children'}"/>
        </div>

        <div v-if="forms.addManually">
            <add-edit-child-manually
                :roles="roles"
                :hasAnyRole="hasAnyRole"
                :group-id="groupId"
                v-on:child-saved="childSaved"/>
        </div>
    </modal>
</template>

<script>
import Modal from "../../../theme/organisms/Modal.vue";
import BasicButton from "../../../theme/atoms/BasicButton.vue";
import Invite from "../../../widgets/SpaceSetup/organisms/Invite.vue";
import AddEditChildManually from "./AddEditChildManually.vue";

export default {
    name: "ChildFormModal",
    components: {
        AddEditChildManually,
        Modal, BasicButton, Invite
    },
    props: {
        value: {
            type: Boolean,
            required: false,
            default() {
                return false
            }
        },
        childId: {
            type: Number,
            default: null
        },
        hasAnyRole: {
            type: Function,
            required: false,
        },
        roles: {
            type: Array,
            required: false,
        },
        groupId: {
            type: Number,
            required: false,
            default: null
        },
        initialForm: {
            type: String,
            default: 'invite'
        },
    },
    watch: {
        value: function (val) {
            this.toggleModal = val;
        },
        toggleModal: function (val) {
            this.$emit('input', val);
        },
        initialForm: function (val) {
            this.switchForms(val);
        }
    },
    data() {
        return {
            toggleModal: false,
            forms: {
                invite: this.initialForm === 'invite',
                addManually: this.initialForm === 'manually',
            }
        }
    },
    methods: {
        switchForms(form) {
            Object.keys(this.forms).forEach(key => {
                this.forms[key] = key === form;
            });
        },
        childSaved(saveAndAddAnother) {
            this.$emit('success');

            this.$notify({
                type: 'success',
                text: trans('general.page.children.save_' + (this.childId ? 'update' : 'new'))
            });

            if (saveAndAddAnother) {
                return;
            }
            this.toggleModal = false;
        },
        reset() {
            this.switchForms('invite');
        }
    },
}
</script>

<style>
.createChildModal .modal-dialog {
    transition: .2s ease-in-out !important;
}
</style>
